import _sfc_main from "./BuyBoxSizeColor2.mjs";
/* empty css                  */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxSizeColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-5a5e3827"]]);
export {
  BuyBoxSizeColor as default
};
//# sourceMappingURL=BuyBoxSizeColor.mjs.map
